import { NgModule } from '@angular/core';
import { TranslateModule } from '@xref/ngx';

import { OpenIdSsoComponent } from './open-id-sso.component';

@NgModule({
    imports: [
        TranslateModule
    ],
    exports: [],
    declarations: [OpenIdSsoComponent],
    providers: [],
})
export class OpenIdSsoModule { }
